import { useSelector } from 'react-redux'
import { Box } from '@mui/material'
import SortByList from '../../../components/PageHelpers/Sort'
import { selectUserBatchStatusDetails } from '../../../redux/features/userBatchStatusDetails/userBatchStatusDetailsSlice'
import { filterStatusDetailsEmployeesList, sortStatusDetailsEmployeesList } from '../../../redux/features/userBatchStatusDetails/userBatchStatusDetailsThunk'
import FilterBy from '../../../components/PageHelpers/FilterBy'

const Desktop = () => {
  const batchStatusDetails = useSelector(selectUserBatchStatusDetails)

  return (

    <Box sx={styles.sortAndFilters}>
      <SortByList
          store={batchStatusDetails}
          actionToDispatch={sortStatusDetailsEmployeesList}
          customStyles={styles.sortBy} />
      <FilterBy
      store={batchStatusDetails}
        actionToDispatch={filterStatusDetailsEmployeesList}
        customStyle={styles.filter}
      />
        </Box>

  )
}
const styles = {
  sortAndFilters: {
    display: { xs: 'none', sm: 'flex' },
    justifyContent: 'end',
    my: '10px',
  },
  sortBy: {
    margin: { xs: '0 15px 15px', sm: '0 15px' },
    '& p': {
      fontSize: { xs: '14px', sm: '16px' },
    },
    '& button': {
      fontSize: { xs: '14px', sm: '16px' },
    },
  },
  filter: {
    marginRight: '0px',
  },
}
export default Desktop
